import { render, staticRenderFns } from "./ModalReminderFrame.vue?vue&type=template&id=567f7d09&scoped=true&"
import script from "./ModalReminderFrame.vue?vue&type=script&lang=js&"
export * from "./ModalReminderFrame.vue?vue&type=script&lang=js&"
import style0 from "./ModalReminderFrame.vue?vue&type=style&index=0&id=567f7d09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f7d09",
  null
  
)

export default component.exports